import React from "react";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { useFormikContext } from "formik";

import FormDropdown from "../../../../../base/form-dropdown";
import DatePicker, {
  FORM_DROPDOWN_LABEL_POSITION,
} from "../../../../../base/date-picker";
import FormTextInput from "../../../../../base/form-text-input";
import { ID_VERIFICATION_TYPES } from "../../../../../../config/constant";
import FormMeta from "../form-meta/index.json";

const DocumentDetailsFormView = () => {
  const {
    initialValues,
    handleChange,
    values,
    setFieldValue,
    errors,
    isSubmitting,
    submitCount,
  } = useFormikContext();

  const showErrors = submitCount > 0;

  return (
    <Grid item container direction="column" className="doc-details-section">
      <Typography className="font-weight-600">
        Document Details
        <Divider />
      </Typography>

      <FormDropdown
        id={FormMeta.documentType.id}
        name={FormMeta.documentType.id}
        label={FormMeta.documentType.label}
        required={FormMeta.documentType.required}
        options={FormMeta.documentType.options}
        value={values[FormMeta.documentType.id]}
        errorText={showErrors && errors[FormMeta.documentType.id]}
        onChangeValue={handleChange}
      />

      <FormTextInput
        id={FormMeta.documentId.id}
        name={FormMeta.documentId.id}
        label={FormMeta.documentId.lablel}
        required={FormMeta.documentId.required}
        value={values[FormMeta.documentId.id]}
        errorText={showErrors && errors[FormMeta.documentId.id]}
        onChangeInput={handleChange}
      />
      <DatePicker
        id={FormMeta.issuedDate.id}
        label={FormMeta.issuedDate.lablel}
        labelPosition={FORM_DROPDOWN_LABEL_POSITION.TOP}
        fullWidth
        required={FormMeta.issuedDate.required}
        showYearDropdown
        showMonthDropdown
        selectedDate={values[FormMeta.issuedDate.id]}
        errorText={showErrors && errors[FormMeta.issuedDate.id]}
        onChangeDate={(date) => setFieldValue(FormMeta.issuedDate.id, date)}
      />
      <DatePicker
        id={FormMeta.expiryDate.id}
        label={FormMeta.expiryDate.lablel}
        labelPosition={FORM_DROPDOWN_LABEL_POSITION.TOP}
        fullWidth
        required={FormMeta.expiryDate.required}
        showYearDropdown
        showMonthDropdown
        selectedDate={values[FormMeta.expiryDate.id]}
        errorText={showErrors && errors[FormMeta.expiryDate.id]}
        onChangeDate={(date) => setFieldValue(FormMeta.expiryDate.id, date)}
      />
      <FormTextInput
        id={FormMeta.fullName.id}
        name={FormMeta.fullName.id}
        label={FormMeta.fullName.lablel}
        required={FormMeta.fullName.required}
        value={values[FormMeta.fullName.id]}
        errorText={showErrors && errors[FormMeta.fullName.id]}
        onChangeInput={handleChange}
      />
      <DatePicker
        id={FormMeta.dateOfBirth.id}
        label={FormMeta.dateOfBirth.lablel}
        labelPosition={FORM_DROPDOWN_LABEL_POSITION.TOP}
        fullWidth
        required={FormMeta.dateOfBirth.required}
        showYearDropdown
        showMonthDropdown
        selectedDate={values[FormMeta.dateOfBirth.id]}
        errorText={showErrors && errors[FormMeta.dateOfBirth.id]}
        onChangeDate={(date) => setFieldValue(FormMeta.dateOfBirth.id, date)}
      />
    </Grid>
  );
};

export default DocumentDetailsFormView;
